import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { Link } from 'react-router-dom';
import '../../styles/assets.css'
import { utils, write } from 'xlsx';
import { ToastContainer, toast } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';

const AssetMasterReport = () => {
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [showFilter, setShowFilter] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const token = localStorage.getItem("token");
    const handleErrors = useHandleErrors();
    const [loading, setLoading] = useState(false);
    const hasFetchedRef = useRef(false);



    useEffect(() => {
        const fetchAssetReport = async () => {
            setLoading(true)
            try {
                const path = "/getAssetMasterReport";
                const URL = process.env.REACT_APP_BE_URL + path;
                const response = await axios.get(URL, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                })
                if (response.status === 200) {

                    setData(response.data);
                    setFilteredData(response.data);
                } else {
                    handleErrors(response);
                }
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 404) {
                        // Handle 404 status code separately
                        setData([]);
                        setFilteredData([]);
                    } else {
                        handleErrors(error.response);
                    }
                } else {
                    toast.error("Something went wrong. Please try again later.", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            } finally {
                setLoading(false);
            }
        }
        if (!hasFetchedRef.current) {
            fetchAssetReport()
            hasFetchedRef.current = true;
        }

    }, []);

    const handleSearch = (event) => {
        const keyword = event.target.value;
        setSearch(keyword);
        if (keyword !== '') {
            const results = data.filter((item) => {
                return (
                    item.AssetId?.toLowerCase().includes(keyword?.toLowerCase()) ||
                    item.CategoryType?.toLowerCase().includes(keyword?.toLowerCase()) ||
                    item.AssertType?.toLowerCase().includes(keyword?.toLowerCase()) ||
                    item.ProductType?.toLowerCase().includes(keyword?.toLowerCase()) ||
                    item.Status?.toLowerCase().includes(keyword?.toLowerCase())
                );
            });
            setFilteredData(results);
        } else {
            setFilteredData(data);
        }
    };


    const sendEmail = (email) => {
        // Excel generation logic
        const ws = utils.json_to_sheet(filteredData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Asset Inventory');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

        // Convert the Excel file to a Base64 string
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
            const base64data = reader.result.split(',')[1]; // Get the Base64 string without the prefix

            // Create a downloadable link for the attachment
            const link = document.createElement('a');
            link.href = reader.result;
            const today = new Date();
            const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
            const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
            const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
            const formattedDate = `${year}${month}${day}`;
            link.download = `WW360-Asset_Master_Report_${formattedDate}.xlsx`;

            // Simulate a click to download the attachment
            link.click();

            // Prepare the mailto link (without attachment)
            const subject = "Asset Inventory List";
            const body = 'Please find the attached file.';
            const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

            toast.info('The Excel file has been generated and downloaded. Please attach the file manually to your email.', {
                position: toast.POSITION.TOP_CENTER,
            });

            setTimeout(() => {
                window.location.href = mailtoLink;
            }, 3000);

        };
    };

    const shareData = {
        title: 'Asset Master List',
        text: 'Check out the Asset Master list',
        url: window.location.href
    };

    const handleShare = async () => {
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Asset Master");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const today = new Date();
        const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
        const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
        const formattedDate = `${year}${month}${day}`;
        saveAs(blob, `WW360-Asset_Master_Report_${formattedDate}.xlsx`);
    };

    useEffect(() => {
        const preloading = document.getElementById("preloading");
        setTimeout(() => {
            if (preloading) {
                preloading.style.display = "none";
            }
        }, 400);
    }, []);


    const openModal = (item) => {
        setModalData(item);
    };

    const closeModal = () => {
        setModalData(false);
    };
    // pagination
    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredData.length / recordsPerPage);
    const paginate = pageNumber => setCurrentPage(pageNumber);
    // pagination end

    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">Master Report</h3>
                        </div>
                        <div className="col-auto">
                            <Link to={'/RegisterAsset'} className="btn btn-primary mt-lg-0 mt-4">
                                <i className="ri-add-circle-line"></i> Register New
                            </Link>
                        </div>
                    </div>
                    {data?.length === 0 ? (
                        <div class="container">
                            <div class="row vh-50 justify-content-center align-items-center">
                                <div class="col-auto">
                                    <div class="no-data-wrapper">
                                        <div class="no-data-found">
                                            <i class="ri-file-damage-fill"></i>
                                            <div class="bounce"><i class="ri-search-eye-line"></i></div>
                                            <p>No Data Found</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className="row align-items-center justify-content-center mb-4">
                                <div className="col-lg-5 col-md-8 col-sm-10">
                                    <div className="container-fluid row-rounded mb-0">
                                        <div className="row px-2 py-0">
                                            <div className="input-group mb-0">
                                                <input 
                                                    type="search" 
                                                    className="form-control search-input" 
                                                    placeholder="Search by ID, Category, Product Type, or Status..." 
                                                    value={search} 
                                                    onChange={handleSearch} 
                                                />
                                                <div className="input-group-append">
                                                    <button className="btn btn-primary" type="button" title="Search" onClick={handleSearch}>
                                                        <i className="ri-menu-search-line"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <small className="form-text text-muted text-center mt-0">
                                        <i className="ri-information-2-line"></i> Search by Asset ID, Category Type, Product Type, or Status
                                    </small>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card mb-4">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col">
                                                    <h5 className="title mt-1 mb-0">Summary</h5>
                                                </div>
                                                <div className="col-auto">
                                                    <button
                                                        type="button"
                                                        title="Email"
                                                        rel="tooltip"
                                                        className="btn btn-light btn-circle ml-2"
                                                        onClick={() => sendEmail('')}
                                                    >
                                                        <i className="ri-mail-send-fill"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        title="Share"
                                                        rel="tooltip"
                                                        className="btn btn-light btn-circle ml-2"
                                                        onClick={handleShare}
                                                    >
                                                        <i className="ri-share-fill"></i>
                                                    </button>
                                                    <button type="button" title="Export" className="btn btn-light btn-circle ml-2" onClick={exportToExcel}>
                                                        <i className="ri-export-fill"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-12">
                                                    <div className="table-responsive asset-information">
                                                        <table className="table grid">
                                                            <thead className="bg-light">
                                                                <tr>
                                                                    <th>S.No.</th>
                                                                    <th>ID  </th>
                                                                    <th>Category Type  </th>
                                                                    <th>Product Type  </th>
                                                                    <th>Purchase Date  </th>
                                                                    <th>Purchase Cost  </th>
                                                                    <th>Warranty EndDate </th>
                                                                    <th>Status </th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentRecords.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1 + indexOfFirstRecord}</td>
                                                                        <td>{item.AssetId}</td>                                                      
                                                                        <td>{item.CategoryType}</td>
                                                                        <td>{item.ProductType}</td>
                                                                        <td>{moment(item.PurchaseDate).format("DD-MM-YYYY")}</td>
                                                                        <td>
                                                                            {typeof item.PurchaseCost === 'string' && item.PurchaseCost.length > 15
                                                                                ? parseFloat(item.PurchaseCost).toExponential(2) // Adjust the precision as needed
                                                                                : item.PurchaseCost.toLocaleString()}
                                                                        </td>
                                                                        <td>{item.WarrantyEndDate ? moment(item.WarrantyEndDate).format("DD-MM-YYYY") : 'NA'}</td>
                                                                        <td>
                                                                            <span className={`badge border ${item.Status.toLowerCase() === 'active' ? 'border-info text-info' : item.Status.toLowerCase() === 'inactive' ? 'border-light text-light' : item.Status.toLowerCase() === 'assigned' ? 'border-success text-success' : 'border-warning text-warning'} status`}>
                                                                                <i className={`ri-${item.Status.toLowerCase() === 'active' ? 'thumb-up-fill' : item.Status.toLowerCase() === 'inactive' ? 'thumb-down-line' : item.Status.toLowerCase() === 'assigned' ? 'map-pin-user-fill' : 'map-pin-line'}`}></i>
                                                                                {` ${item.Status}`}
                                                                            </span>
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <button className="btn btn-link text-info btn-action" type="button" title="List View" onClick={() => openModal(item)}>
                                                                                <i className="ri-layout-horizontal-line"></i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="container-fluid">
                                                        <div className="row border-top pt-3">
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Records</p>
                                                            </div>
                                                            <div className="col-1 record-drop">
                                                                <select className="form-control" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                                    <option value="5">5</option>
                                                                    <option value="10">10</option>
                                                                    <option value="15">15</option>
                                                                    <option value="20">20</option>
                                                                    <option value="25">25</option>
                                                                </select>
                                                            </div>
                                                            <div className="col">
                                                                <nav>
                                                                    <ul className="pagination justify-content-center">
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-double-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage - 1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                                            <li key={index + 1} className={`page-item ${index + 1 === currentPage ? 'active' : ''}`}>
                                                                                <button className="page-link" onClick={() => paginate(index + 1)}>
                                                                                    {index + 1}
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                                                                                <i className="ri-arrow-right-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(totalPages)}>
                                                                                <i className="ri-arrow-right-double-fill"></i>
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                            </div>
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Page Showing {currentPage} of {totalPages}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Modal */}
            {
                modalData && (
                    <div className="modal" tabIndex="-1" role="dialog" style={{ display: 'block', textAlign: 'center' }}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Asset Details</h5>
                                    <button type="button" className="close" onClick={() => setModalData(null)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">ID:</span>
                                        <span className="modal-detail-value">{modalData.AssetId}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Category Type:</span>
                                        <span className="modal-detail-value">{modalData.CategoryType}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Purchase Date:</span>
                                        <span className="modal-detail-value">{moment(modalData.PurchaseDate).format("DD-MM-YYYY")}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Purchase Cost:</span>
                                        <span className="modal-detail-value">
                                            {typeof modalData.PurchaseCost === 'string' && modalData.PurchaseCost.length > 15
                                                ? parseFloat(modalData.PurchaseCost).toExponential(2)
                                                : modalData.PurchaseCost.toLocaleString()}
                                        </span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Purchase Order:</span>
                                        <span className="modal-detail-value">{modalData.PurchaseOrder}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Model:</span>
                                        <span className="modal-detail-value">{modalData.Model}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Invoice Date:</span>
                                        <span className="modal-detail-value">{moment(modalData.InvoiceDate).format("DD-MM-YYYY")}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Invoice Number:</span>
                                        <span className="modal-detail-value">{modalData.InvoiceNumber}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Invoice File:</span>
                                        <span className="modal-detail-value">
                                            {modalData.InvoiceFile ? (
                                                <a href={modalData.InvoiceFile} target="_blank" rel="noopener noreferrer">
                                                    {modalData.InvoiceFile.split('?')[0].split('/').pop().length > 10
                                                        ? `${modalData.InvoiceFile.split('?')[0].split('/').pop().slice(0, 10)}....`
                                                        : modalData.InvoiceFile.split('?')[0].split('/').pop()}
                                                </a>
                                            ) : (
                                                'No file available'
                                            )}
                                        </span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Supplier Details:</span>
                                        <span className="modal-detail-value">{modalData.SupplierDetails}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Supplier Contact:</span>
                                        <span className="modal-detail-value">{modalData.SupplierContact}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Supplier Address:</span>
                                        <span className="modal-detail-value">{modalData.SupplierAddress}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Warranty Start Date:</span>
                                        <span className="modal-detail-value">{moment(modalData.WarrantyStartDate).format("DD-MM-YYYY")}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Warranty End Date:</span>
                                        <span className="modal-detail-value">{modalData.WarrantyEndDate ? moment(modalData.WarrantyEndDate).format("DD-MM-YYYY") : 'NA'}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Asset Condition:</span>
                                        <span className="modal-detail-value"><span className="badge badge-success">{modalData.AssetCondition}</span></span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Assigned To:</span>
                                        <span className="modal-detail-value">{modalData.assignTo}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Asset Type:</span>
                                        <span className="modal-detail-value">{modalData.AssertType}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Status:</span>
                                        <span className="modal-detail-value"><span className="badge badge-success">{modalData.Status}</span></span>
                                    </div>
                                </div>
                                <div className="modal-footer" style={{ display: 'block', textAlign: 'center' }}>
                                    <button type="button" className="btn btn-secondary" onClick={() => setModalData(null)}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </div >
    );

};


export default AssetMasterReport;
